"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNotificationSpecialtyUpdateDto = instanceOfNotificationSpecialtyUpdateDto;
exports.NotificationSpecialtyUpdateDtoFromJSON = NotificationSpecialtyUpdateDtoFromJSON;
exports.NotificationSpecialtyUpdateDtoFromJSONTyped = NotificationSpecialtyUpdateDtoFromJSONTyped;
exports.NotificationSpecialtyUpdateDtoToJSON = NotificationSpecialtyUpdateDtoToJSON;
exports.NotificationSpecialtyUpdateDtoToJSONTyped = NotificationSpecialtyUpdateDtoToJSONTyped;
const SpecialtyNotificationScope_1 = require("./SpecialtyNotificationScope");
/**
 * Check if a given object implements the NotificationSpecialtyUpdateDto interface.
 */
function instanceOfNotificationSpecialtyUpdateDto(value) {
    if (!('scope' in value) || value['scope'] === undefined)
        return false;
    if (!('specialtyCodes' in value) || value['specialtyCodes'] === undefined)
        return false;
    return true;
}
function NotificationSpecialtyUpdateDtoFromJSON(json) {
    return NotificationSpecialtyUpdateDtoFromJSONTyped(json, false);
}
function NotificationSpecialtyUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'scope': (0, SpecialtyNotificationScope_1.SpecialtyNotificationScopeFromJSON)(json['scope']),
        'specialtyCodes': json['specialtyCodes'],
    };
}
function NotificationSpecialtyUpdateDtoToJSON(json) {
    return NotificationSpecialtyUpdateDtoToJSONTyped(json, false);
}
function NotificationSpecialtyUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'scope': (0, SpecialtyNotificationScope_1.SpecialtyNotificationScopeToJSON)(value['scope']),
        'specialtyCodes': value['specialtyCodes'],
    };
}
//# sourceMappingURL=NotificationSpecialtyUpdateDto.js.map